module.exports = __webpack_public_path__ + "img/4-2.8dd6e957.png";